import { CONSTANTS } from '../shared/constants';
import { ElementRef } from '@angular/core';
import { PhoneNumberPipe } from '../pipes/phone-number.pipe';

export function responseIsSuccess(response): boolean {
  return response && response['API_Message'] && response['API_Message'][0]['Message'] === CONSTANTS.status.success;
};

export function valueIsNullOrUndefined(value): boolean {
  return value === null || !value;
};

export function expirationDateIsValid(month, year): boolean {
  let validExpirationDate = false;
  const effectiveDate = new Date();
  const currentMonth = effectiveDate.getMonth()+1;
  const currentYear = effectiveDate.getFullYear();
  year === currentYear ? validExpirationDate = month >= currentMonth : validExpirationDate = true;
  return validExpirationDate;
};

export function onPhoneNumberEntered(element: ElementRef) {  
  let value = element['target'].value.replace(/[^0-9]/g, '').slice(0,10);
  const phoneNumberFormatted = new PhoneNumberPipe().transform(value);
  element['target'].value = phoneNumberFormatted;
}

export function onCreditCardNumberEntered(element: ElementRef) {
  let number = element['target'].value;
  // Visa
  // let re = new RegExp('^4');
  let re = new RegExp('^4[0-9]{12}(?:[0-9]{3})?$');
  if (number.match(re) != null) {
    return 'Visa';
  }

  // Mastercard 
  re = new RegExp('^5[1-5][0-9]{14}$');
  if (number.match(re) != null) {
    return 'Mastercard';
  }

  // Mastercard 2017 BINs expansion
  if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number)) {
    return 'Mastercard';
  } 

  // AMEX
  // re = new RegExp('^3[47]');
  re = new RegExp('^3[47][0-9]{13}$');
  if (number.match(re) != null) {
    return 'AMEX';
  }

  // Discover
  // re = new RegExp('^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)');
  re = new RegExp('^6(?:011|5[0-9]{2})[0-9]{12}$');
  if (number.match(re) != null) {
    return 'Discover';
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/helper-functions.ts